import { Loader2Icon } from "lucide-react";
import type { ComponentProps } from "react";
import { cn } from "$/modules/shared/lib/utils";

function Spinner({
	className,
	"aria-label": label,
	...props
}: ComponentProps<"svg">) {
	return (
		<Loader2Icon
			role={label ? "status" : undefined}
			aria-label={label}
			aria-hidden={label ? undefined : true}
			className={cn("size-4 animate-spin", className)}
			{...props}
		/>
	);
}

export { Spinner };
